module.exports = __webpack_public_path__ + "static/img/oa_online.0c6ae1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oa_online.png
// module id = 310
// module chunks = 1